import { createSelector } from 'reselect';
import { fillLocalizedString } from '@synergy/models';
import urlJoin from 'url-join';

import { AppState } from '../../../../../store/models/app-state';
import { StaticSitesDetailRequest } from '../models/static-sites-detail-request';
import { StaticSitesFormValues } from '../models/static-sites-form-values';

const staticSitesDetailState = (state: AppState) => state.contentManagement.staticSites.staticSitesDetail;
const supportedLocales = (state: AppState) => state.supportedLocales;

export const staticSitesDetailSelector = createSelector(staticSitesDetailState, state => state.staticSites);
export const staticSitesDetailRequestingSelector = createSelector(staticSitesDetailState, state => state.requesting);
export const staticSitesDetailNonUniqueErrorSelector = createSelector(
    staticSitesDetailState,
    state => state.hasNonUniqueProperties
);
export const staticSitesDetailFormValues = createSelector(
    [staticSitesDetailState, supportedLocales],
    (state, locales) => {
        const staticSite = state.staticSites;
        const getLocalizedString = (values: { [key: string]: string }) => {
            const localizedString: { [key: string]: string } = {};
            locales.forEach(locale => (localizedString[locale] = values[locale] ?? ''));
            return localizedString;
        };

        return {
            ...staticSite,
            text: getLocalizedString(staticSite?.text ?? {}),
            title: getLocalizedString(staticSite?.title ?? {}),
            path: staticSite?.path ?? '',
        };
    }
);

export const staticSitesDetailRequestSelector = (values: StaticSitesFormValues) =>
    createSelector(staticSitesDetailState, state => {
        const request: StaticSitesDetailRequest = {
            id: state.staticSites?.id,
            text: fillLocalizedString(values.text),
            title: fillLocalizedString(values.title),
            path: urlJoin('/', values.path ?? ''),
        };

        return request;
    });
